export default __webpack_public_path__ + "static/media/boarding-pass.5796bd28.svg";